import { gql } from '@apollo/client';

const getUserGroups = () => {
    return {
        query: gql`
            query GetUserGroups {
                getUserGroups {
                    count
                    pages
                    pageSize
                    page
                    nodes
                }
            }
        `,
    };
};

export default getUserGroups;
